import { useEffect, useState } from "react";
import { Modal } from "../ui/Modal"
import { sharedData } from "../../sharedData/sharedData";
import { useCallback } from "react";
import { utilityService } from "../../requests/utilityService";
import { Textarea } from "../ui/Textarea";
import { diligenceObservable } from "../../observers/deligenceObservable";

export const CountryRiskPopup = ({ownerId, openPopup}) => {
    const entityId = sharedData.get("entityId");
    const [ popupModalOpen, setPopupModalOpen ] = useState(openPopup);
    const [ popupModalMessage, setPopupModalMessage ] = useState("");
    const [ showTextArea, setShowTextArea ] = useState(false);
    const [ highRiskReason, setHighRiskReason ] = useState("");
    const [ requestResponseModalOpen , setRequestResponseModalOpen  ] = useState(false);
    const [ requestResponseModalMessage , setRequestResponseModalMessage  ] = useState("");
    const [confirmMistakeChecked, setConfirmMistakeChecked] = useState(false); // NEW STATE

    const updateEntityDiligence = useCallback(async (status)=>{
        const response = await utilityService.updateDiligenceStatus(entityId, status);
        diligenceObservable.remove(ownerId);
        diligenceObservable.setValue(status, ownerId);
        if (response.ok) {
            setRequestResponseModalMessage("Successfully updated diligence status to " + status);
            setRequestResponseModalOpen(true);
        } else {
            setRequestResponseModalMessage("Failed to update diligence status to " + status);
            setRequestResponseModalOpen(true);
        }
    }, [entityId, ownerId]);

    const handleDueDiligence = useCallback((e, status)=>{
        e.preventDefault();
        setRequestResponseModalMessage(`Updating diligence status to '${status}'`);
        setRequestResponseModalOpen(true);
        updateEntityDiligence(status);
    }, [updateEntityDiligence]);

    const handleStandardDueDiligence = useCallback((e)=>{
        e.preventDefault();
        setShowTextArea(true);
    }, []);

    const submitStandardDueDiligence = useCallback((e)=>{
        e.preventDefault();
        setRequestResponseModalMessage(`Updating diligence status to 'Standard'`);
        setRequestResponseModalOpen(true);
        updateEntityDiligence("Standard");
    }, [updateEntityDiligence]);

    const handleSendMail = useCallback((e, userType)=>{
        e.preventDefault();
        setRequestResponseModalMessage(`Sending mail...`);
        setRequestResponseModalMessage(true);
        const response = utilityService.sendMail({requestId: sharedData.get("requestId"), userType: "COD"});
        if (response != null ){
            setRequestResponseModalMessage("Email sent successfully!");
        } else {
            setRequestResponseModalMessage("Failed to send email");
        }
    },[]);

    
    return (
        <>
            { popupModalOpen && (
            <div
              className="modal"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
              }}
            >
              <div
                className="modal-content"
                style={{
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  textAlign: "center",
                  position: "relative",
                  width: "700px"
                }}
              >
                <div style={{display:"inline-block"}}>
                <p style={{ textAlign: "left" }}>The answers to your risk assessment indicate that this client/counterparty should be treated as High Risk. We recommend that enhanced due diligence is applied</p>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px" }}>
                  <button style={{
                    marginTop: "10px",
                    padding: "8px",
                    border: "none",
                    background: "#07b1b0",
                    color: "white",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }} onClick={handleStandardDueDiligence}>Proceed with Standard Due Diligence</button>
                  <button style={{
                    marginTop: "10px",
                    padding: "8px",
                    border: "none",
                    background: "#07b1b0",
                    color: "white",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}onClick={(e) => {handleDueDiligence(e, "Enhanced"); setPopupModalOpen(false)}}
                  >Proceed with Enhanced Due Diligence</button>
                  <button style={{
                    marginTop: "10px",
                    padding: "8px",
                    border: "none",
                    background: "#07b1b0",
                    color: "white",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={(e) => handleSendMail(e, "COD")}
                  >Refer to Compliance on Demand</button>
                </div>
                {showTextArea && (
                  <div style={{ marginTop: "15px", textAlign: "left", display: "inline-block", width: "100%" }}>
                    <Textarea 
                        label={"Please provide details of why you believe the client/counterparty is not high risk:"}
                        name={"highRiskReason"}
                        value={highRiskReason}
                        onChange={(e) => { setHighRiskReason(e.target.value) }}
                    />
                    <button style={{
                      marginTop: "10px",
                      padding: "8px",
                      border: "none",
                      background: "#07b1b0",
                      color: "white",
                      borderRadius: "4px",
                      cursor: "pointer",
                      float: "left"
                    }} onClick={(e) => {submitStandardDueDiligence(e); setPopupModalOpen(false)}}
                    >Submit</button>
                  </div>
                )}
                <p style={{ textAlign: "left" }}>If you are unsure</p>
                <button style={{
                  marginTop: "10px",
                  padding: "8px",
                  border: "none",
                  background: "#07b1b0",
                  color: "white",
                  borderRadius: "4px",
                  cursor: "pointer",
                  float: "left"
                }}
                onClick={(e) => handleSendMail(e, "MLNO")}
                >Refer to your MLNO</button>
                </div>
                {/* NEW CHECKBOX AND CANCEL BUTTON */}
            <div style={{ marginTop: "20px", textAlign: "left" }}>
              <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <input
                  type="checkbox"
                  checked={confirmMistakeChecked}
                  onChange={(e) => setConfirmMistakeChecked(e.target.checked)}
                  style={{width:"auto", margin:"0"}}
                />
                I have selected this jurisdiction by mistake
              </label>

              <button
                style={{
                  background: confirmMistakeChecked ? "#F87171" : "#ccc",
                  color: confirmMistakeChecked ? "white" : "#666",
                  cursor: confirmMistakeChecked ? "pointer" : "not-allowed",
                  marginTop: "15px",
                  border:"none", padding:"10px 15px",
                  borderRadius:"8px"
                }}
                disabled={!confirmMistakeChecked}
                onClick={() => setPopupModalOpen(false)}
              >
                Cancel
              </button>
            </div>
              </div>
            </div>
          )}

            {requestResponseModalOpen && <Modal modalMessage={requestResponseModalMessage} onClick={(e) => {e.preventDefault(); setRequestResponseModalOpen(false)}} />}
        </>
    )
}